import moment from 'moment';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { offlineQueueDB } from '../../../service-worker/offline-queue.database.typed';
import { LegacyDriverNameInterceptor } from '../interceptors/legacy-driver-name.interceptor';
import { TimestampInterceptor } from '../interceptors/timestamp.interceptor';

@Injectable({
    providedIn: 'root'
})
export class NetworkService {

    constructor(
        private readonly driverNameInterceptor: LegacyDriverNameInterceptor,
        private readonly timestampInteceptor: TimestampInterceptor
    ) {
    }

    checkOnlineStatus() {
        return navigator.onLine;
    }

    /**
     * Queues the given request.
     *
     * Note: it is assumed that this function is used from an offline context. If this is not case, the impl should be altered.
     */
    queueRequest(req: { [k: string]: any }): void {
        offlineQueueDB.httpRequests.add({
            type: req.type,
            endpoint: req.endpoint,
            payload: this.enhancePayloadForSW(req.payload, req.endpoint, true /* assuming queueRequest() is always called from an offline context */),
            retryTotal: 0,
            retryLatestDate: '',
            createdAt: moment().toISOString(true)
        }).then();
    }

    enhancePayloadForSW(payload, endpoint, offline?: boolean) {
      return _.merge(
          this.driverNameInterceptor.interceptBody(payload, endpoint),
          this.timestampInteceptor.interceptBody(payload, endpoint),
          {offlineRequest: !!offline}
        );
    }
}
